import React from 'react'
import './MainBrands.css'

const MainBrands = () => {
    return (
        <div className='MainBrandsWrap'>

            <div className='MainBrandsCont'>

                <div className='LeadingBrandMain logo13'>

                </div>
                <div className='LeadingBrandMain logo14'>

                </div>
                <div className='LeadingBrandMain logo15'>

                </div>
            </div>
        </div>
    )
}

export default MainBrands